class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        if (event.target && event.target.tagName === 'SELECT') return;
        this.debouncedOnSubmit(event);
      });
      facetForm.addEventListener('change', (event) => {
        if (event.target && event.target.tagName === 'SELECT') {
          this.onSubmitHandler(event);
        } else {
          this.debouncedOnSubmit(event);
        }
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper && typeof onKeyUpEscape === 'function') {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static cleanUpLoading() {
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    if (countContainer) countContainer.classList.remove('loading');
    if (countContainerDesktop) countContainerDesktop.classList.remove('loading');

    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionEl = productGridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .loading__spinner, .loading-overlay__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const urlParams = new URLSearchParams(searchParams);
    const sortByParam = urlParams.get('sort_by');
    if (sortByParam) {
      FacetFiltersForm.currentSortBy = sortByParam;
    }

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .loading__spinner, .loading-overlay__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionEl = productGridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      if (!section.section) return;
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
      })
      .catch((error) => {
        console.error('FacetFiltersForm error:', error);
        FacetFiltersForm.cleanUpLoading();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    try {
      const cached = FacetFiltersForm.filterData.find(filterDataUrl);
      if (!cached) return;
      const html = cached.html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
    } catch (error) {
      console.error('FacetFiltersForm cache render error:', error);
      FacetFiltersForm.cleanUpLoading();
    }
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newContainer = parsedHTML.getElementById('ProductGridContainer');
    if (newContainer) {
      productGridContainer.innerHTML = newContainer.innerHTML;
    }

    const collectionEl = productGridContainer.querySelector('.collection');
    if (collectionEl) {
      collectionEl.classList.remove('loading');
    }

    productGridContainer.querySelectorAll('.scroll-trigger').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCountDesktop') || parsedHTML.getElementById('ProductCount');
    const count = countElement ? countElement.innerHTML : '';

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      if (count) container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      if (count) containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .loading__spinner, .loading-overlay__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collectionEl = productGridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event && event.target ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            const prevEl = document.getElementById(previousElementId);
            if (prevEl) {
              prevEl.after(elementToRender);
              return;
            }
          }
        }

        if (elementToRender.parentElement) {
          const parentEl = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
          if (parentEl) {
            parentEl.before(elementToRender);
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
      const closestFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestFilter ? closestFilter.id : null;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, closestFilter);
        const mobileTarget = document.getElementById(closestJSFilterID);
        if (mobileTarget) {
          FacetFiltersForm.renderMobileCounts(countsToRender, mobileTarget);
        }

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        if (newFacetDetailsElement) {
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute && event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (source && target) {
        target.innerHTML = source.innerHTML;
      }
    });

    const sourceSorting = html.querySelectorAll('.sorting');
    const targetSorting = document.querySelectorAll('.sorting');
    targetSorting.forEach((target, index) => {
      if (sourceSorting[index]) {
        target.innerHTML = sourceSorting[index].innerHTML;
      }
    });

    // Restore selected sort_by value on all sort select inputs AND re-attach
    // change listeners so newly rendered selects keep working after every AJAX swap.
    FacetFiltersForm.syncSortSelects();

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') {
        drawer.bindEvents();
      }
    }
  }

  static syncSortSelects() {
    const urlParams = new URLSearchParams(window.location.search);
    const activeSortBy = urlParams.get('sort_by') || FacetFiltersForm.currentSortBy;

    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      // Restore visual selection
      if (activeSortBy) select.value = activeSortBy;

      // Re-attach change listener if not already marked (avoids duplicates)
      if (!select.dataset.facetListenerAttached) {
        select.dataset.facetListenerAttached = 'true';
        select.addEventListener('change', (event) => {
          // Find the nearest facet-filters-form ancestor to delegate to
          const facetForm = event.target.closest('facet-filters-form');
          if (facetForm && typeof facetForm.onSubmitHandler === 'function') {
            facetForm.onSubmitHandler(event);
          } else {
            // Fallback: find any facet-filters-form on the page
            const anyFacetForm = document.querySelector('facet-filters-form');
            if (anyFacetForm && typeof anyFacetForm.onSubmitHandler === 'function') {
              anyFacetForm.onSubmitHandler(event);
            }
          }
        });
      }
    });
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const productGrid = document.getElementById('product-grid');
    let sectionId = productGrid ? productGrid.dataset.id : null;
    if (!sectionId) {
      const container = document.getElementById('ProductGridContainer');
      const sectionEl = container ? container.closest('.shopify-section') : null;
      if (sectionEl && sectionEl.id) {
        sectionId = sectionEl.id.replace('shopify-section-', '');
      }
    }
    return [
      {
        section: sectionId || '',
      },
    ];
  }

  createSearchParams(form) {
    if (!form) return '';
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event) event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const targetForm = event && event.target ? event.target.closest('form') : null;
    const isMobile = targetForm ? targetForm.id === 'FacetFiltersFormMobile' : false;

    if (event && event.srcElement && event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(targetForm);
      this.onSubmitForm(searchParams, event);
    } else {
      // Collect params from all relevant forms, then merge — deduplicating sort_by
      // so that the triggering form's sort_by always wins.
      const mergedParams = new URLSearchParams();

      // Determine which sort_by to use: prefer the form that triggered the event
      let activeSortBy = null;
      if (targetForm) {
        const triggerSelect = targetForm.querySelector('select[name="sort_by"]');
        if (triggerSelect) activeSortBy = triggerSelect.value;
      }

      sortFilterForms.forEach((form) => {
        const include = isMobile
          ? form.id === 'FacetFiltersFormMobile'
          : form.id !== 'FacetFiltersFormMobile';
        if (!include) return;

        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => {
          // Skip sort_by here — we handle it separately to avoid duplicates
          if (key === 'sort_by') return;
          mergedParams.append(key, value);
        });
      });

      // Apply the winning sort_by value
      if (!activeSortBy) {
        // No sort_by from triggering form — read from URL or static class variable
        activeSortBy =
          new URLSearchParams(window.location.search).get('sort_by') ||
          FacetFiltersForm.currentSortBy;
      }
      if (activeSortBy) {
        mergedParams.set('sort_by', activeSortBy);
        FacetFiltersForm.currentSortBy = activeSortBy;
      }

      this.onSubmitForm(mergedParams.toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.currentSortBy = new URLSearchParams(window.location.search).get('sort_by') || '';
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
// Sync sort selects on initial page load (e.g. back navigation with ?sort_by= in URL)
document.addEventListener('DOMContentLoaded', () => FacetFiltersForm.syncSortSelects());

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
